import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-charcoal text-gray-400 py-12 px-4 text-center text-sm" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <p className="mb-4" data-id="element-32">
          © {new Date().getFullYear()} Protocolo Vientre Plano 40+. Todos los
          derechos reservados.
        </p>
        <div className="flex justify-center items-center gap-6 mb-6" data-id="element-33">
          <button onClick={() => setOpenModal('privacy')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-34">
            Política de Privacidad
          </button>
          <span className="text-gray-600" data-id="element-35">·</span>
          <button onClick={() => setOpenModal('terms')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-36">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-xs opacity-75 max-w-2xl mx-auto leading-relaxed" data-id="element-37">
          Descargo de responsabilidad: La información proporcionada en este
          sitio web y en el material del programa tiene fines educativos e
          informativos únicamente y no pretende sustituir el consejo,
          diagnóstico o tratamiento médico profesional. Siempre busque el
          consejo de su médico u otro proveedor de salud calificado con
          cualquier pregunta que pueda tener con respecto a una condición
          médica.
        </p>
      </div>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-38">
        <p data-id="element-39">
          En Protocolo Vientre Plano 40+ valoramos y respetamos tu privacidad.
          Esta Política de Privacidad describe cómo recopilamos, usamos y
          protegemos tu información personal cuando visitas nuestro sitio web o
          adquieres nuestros productos digitales.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-40">
          1. Información que recopilamos
        </h3>
        <p data-id="element-41">
          Recopilamos información que tú nos proporcionas directamente al
          realizar una compra, como tu nombre, dirección de correo electrónico y
          datos de pago. También podemos recopilar información técnica de forma
          automática, como tu dirección IP, tipo de navegador y páginas
          visitadas, mediante cookies y tecnologías similares.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-42">
          2. Uso de la información
        </h3>
        <p data-id="element-43">
          Utilizamos tu información para procesar tus compras, entregarte el
          material digital adquirido, mejorar la experiencia del sitio web y
          enviarte comunicaciones relevantes sobre tu compra. No vendemos ni
          alquilamos tu información personal a terceros.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-44">
          3. Cookies
        </h3>
        <p data-id="element-45">
          Nuestro sitio utiliza cookies para mejorar la funcionalidad y analizar
          el tráfico. Puedes configurar tu navegador para rechazar cookies,
          aunque esto puede afectar el funcionamiento de algunas partes del
          sitio.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-46">
          4. Seguridad
        </h3>
        <p data-id="element-47">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información personal contra el acceso no autorizado, la
          pérdida o la alteración. Los pagos se procesan a través de plataformas
          seguras y encriptadas.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-48">
          5. Tus derechos
        </h3>
        <p data-id="element-49">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal, así como a oponerte a su tratamiento. También puedes retirar
          tu consentimiento en cualquier momento.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-50">
          6. Cambios en esta política
        </h3>
        <p data-id="element-51">
          Podemos actualizar esta Política de Privacidad ocasionalmente. La
          versión más reciente estará siempre disponible en esta página, con su
          fecha de última actualización.
        </p>

        <p className="text-sm text-gray-500 pt-4 border-t border-gray-200" data-id="element-52">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-53">
        <p data-id="element-54">
          Al acceder y utilizar este sitio web y adquirir el Protocolo Vientre
          Plano 40+, aceptas los siguientes términos y condiciones. Te
          recomendamos leerlos detenidamente antes de realizar cualquier compra.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-55">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-56">
          El Protocolo Vientre Plano 40+ es un producto digital de carácter
          educativo e informativo. No constituye asesoramiento médico,
          diagnóstico ni tratamiento profesional. Consulta siempre con un
          profesional de la salud antes de iniciar cualquier programa
          nutricional o cambio de hábitos.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-57">
          2. Licencia de uso
        </h3>
        <p data-id="element-58">
          Al adquirir el producto, recibes una licencia personal, no exclusiva e
          intransferible para acceder al contenido. Está prohibida la
          reproducción, distribución, copia o reventa del material sin
          autorización expresa por escrito.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-59">
          3. Pago y acceso
        </h3>
        <p data-id="element-60">
          El pago es único y otorga acceso de por vida al material adquirido.
          Una vez confirmado el pago, recibirás los archivos digitales de forma
          instantánea a través del correo electrónico proporcionado.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-61">
          4. Política de reembolsos
        </h3>
        <p data-id="element-62">
          Debido a la naturaleza digital y descargable del producto, todas las
          ventas son finales. Por la entrega inmediata del contenido, no se
          realizan reembolsos una vez que el material ha sido enviado.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-63">
          5. Resultados individuales
        </h3>
        <p data-id="element-64">
          Los resultados pueden variar de una persona a otra y dependen de
          múltiples factores individuales, incluyendo constancia, alimentación,
          salud previa y estilo de vida. No garantizamos resultados específicos.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-65">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-66">
          No nos hacemos responsables por daños directos, indirectos,
          incidentales o consecuentes derivados del uso o la imposibilidad de
          usar el material. El usuario asume la responsabilidad de aplicar la
          información de forma adecuada y bajo supervisión profesional cuando
          corresponda.
        </p>

        <h3 className="font-serif font-bold text-charcoal text-lg pt-2" data-id="element-67">
          7. Modificaciones
        </h3>
        <p data-id="element-68">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. La versión vigente será siempre la publicada en esta página.
        </p>

        <p className="text-sm text-gray-500 pt-4 border-t border-gray-200" data-id="element-69">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
      </LegalModal>
    </footer>;
}